import React, {useState} from "react";
import {yupResolver} from "@hookform/resolvers/yup";
import {useTranslation} from "react-i18next";
import {useDispatch} from "useDispatch";
import {useForm} from "react-hook-form";
import * as yup from "yup";
import {consoleLog} from "utils/utility";
import {toast} from "react-toastify";
import clsx from "clsx";
import {ExclamationCircleIcon} from "@heroicons/react/24/outline";
import T from "components/T";
import {CheckIcon} from "@heroicons/react/24/solid";
import SellerAction from "store/seller/SellerAction";
import BookingCard from "../../components/BookingCard";
import {SellerExtraOfferNoteToReservation} from "types/entities/SellerReservations";
import {Reservation} from "types/entities/Reservation";

export interface OfferNoteFormInputs {
    offer_note: string | null;
}

interface ReservationOfferNoteProps {
    reservation: Reservation;
    className?: string;
}

const ReservationOfferNote = (props: ReservationOfferNoteProps) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const OfferNoteFormSchema = yup.object().shape({
        // offer_note: yup.string().required(t("Invoice note is required field")),
        offer_note: yup.string(),
    });

    const {register, handleSubmit, formState: {errors},} = useForm<OfferNoteFormInputs>({
        resolver: yupResolver(OfferNoteFormSchema),
        defaultValues: {
            offer_note: props.reservation.extra.offer_note ?? null,
        }
    });

    const onErrorHandler = (error: any) => {
        consoleLog("onErrorHandler", error);
    }

    const onSubmitHandler = (data: OfferNoteFormInputs) => {
        if (isLoading) {
            return;
        }
        setIsLoading(true);

        dispatch(SellerAction.fetchSetOfferNoteToReservation(props.reservation.id, data.offer_note))
            .then(r => {
                const updateOfferNote: SellerExtraOfferNoteToReservation = {
                    reservation_id: props.reservation.id,
                    offer_note: r.reservation.extra.offer_note || null,
                }
                dispatch(SellerAction.setExtraOfferNoteToReservation(updateOfferNote));
                toast.success(t("Invoice note added"));
            })
            .catch(error => {
                consoleLog("error", error);
                toast.error(t("Invoice note not added"));
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    return (
        <BookingCard className={clsx("BookingSellerJournal !px-0 !py-0 self-baseline w-full", props.className)}>
            <form
                className={"flex flex-col w-full"}
                onSubmit={handleSubmit(onSubmitHandler, onErrorHandler)}
            >
                <h2 className={clsx("BookingCardTitle font-bold text-xl text-black px-3 py-2.5 xl:px-3 xl:py-3 flex items-center justify-between border-b")}>
                    <div className={"inline-flex items-center gap-x-2"}>
                        <span>{t("Invoice note")}</span>
                    </div>

                    <button
                        className={"bg-green-400 hover:bg-green-500 px-2 py-1 text-white rounded text-base flex flex-row items-center"}
                        onClick={handleSubmit(onSubmitHandler, onErrorHandler)}
                    >
                        <CheckIcon className={"w-4 h-4 mr-1.5"} />
                        <span>{t("Save")}</span>
                    </button>
                </h2>

                <div className={"px-3 py-3"}>
                    <textarea
                        {...register("offer_note")}
                        autoFocus={true}
                        className={"p-2 border-gray-500 border rounded text-base font-medium min-h-[120px] w-full"}
                        name={"offer_note"}
                        required={true}
                    />

                    {errors?.["offer_note"]?.message && (
                        <div className={clsx(
                            "text-red-500 mt-1 text-sm flex flex-row items-center",
                        )}>
                            <div className={clsx("flex flex-row items-center")}>
                                <ExclamationCircleIcon className={"min-w-[18px] min-h-[18px] w-[18px] h-[18px] mr-0.5"} />
                                <T>{errors?.["offer_note"]?.message}</T>
                            </div>
                        </div>
                    )}
                </div>
            </form>
        </BookingCard>
    );
};

export default ReservationOfferNote;